export const users = {
  "user.getUsers": "user.getUsers",
  "user.updateUser": "user.updateUser",
  "user.getUserById": "user.getUserById",
  "users.getRegMens": "users.getRegMens",
  "users.getProfile": "users.getProfile",
  "users.changeUser": "users.changeUser",
  "users.importUser": "users.importUser",
  "users.deleteUser": "users.deleteUser",
  "users.restoreUser": "users.restoreUser",
  "users.getReportRegMenByDealerByPeriod":
    "users.getReportRegMenByDealerByPeriod",
  "users.getReportFileRegMenByDealerByPeriod":
    "users.getReportFileRegMenByDealerByPeriod",
  "users.getReportRegMenByDealerByDealer":
    "users.getReportRegMenByDealerByDealer",
  "users.getReportFileRegMenByDealerByDealer":
    "users.getReportFileRegMenByDealerByDealer",
  "users.getReportRegMenByDealerByRegMen":
    "users.getReportRegMenByDealerByRegMen",
  "users.getReportFileRegMenByDealerByRegMen":
    "users.getReportFileRegMenByDealerByRegMen",
  "users.getReportRegMenByDealerConsolidate":
    "users.getReportRegMenByDealerConsolidate",
  "users.getReportFileRegMenByDealerConsolidate":
    "users.getReportFileRegMenByDealerConsolidate",
  "users.uploadUserToDealer": "users.uploadUserToDealer",
  "users.acceptUploadUserToDealer": "users.acceptUploadUserToDealer",
  "users.access.roles.create": "users.access.roles.create",
  "users.access.roles.edit": "users.access.roles.edit",
  "users.access.roles.copy": "users.access.roles.copy",
  "users.access.roles.user.edit": "users.access.roles.user.edit",
  "users.access.roles.user": "users.access.roles.user",
  "users.access.roles": "users.access.roles",
} as const;
